'use client';

import { CustomImage as Image } from './shared';
import { useState } from 'react';
import styles from './TroubleShootComp.module.css';

const TroubleshootingSteps = [
  {
    seq: 'Step 1',
    title:
      'Place the ring on the charger and ensure it starts charging. Wait for atleast 30 seconds.',
    subtitle: 'The LED will turn white and start blinking.',
    img: 'web_v2/troubleshoot/stepOne.png',
  },
  {
    seq: 'Step 2',
    title:
      "Begin tapping the ring gently on a table while it's on the charger. Look for the RED LED to turn on.",
    subtitle: 'The red light should appear on tapping 20-30 times.',
    img: 'web_v2/troubleshoot/stepTwo.png',
  },
  {
    seq: 'Step 3',
    title:
      'Keep tapping until the RED LED turns off, then wait for a few seconds with the ring on the doc.',
    subtitle: 'The red light should appear on 20-30 taps.',
    img: 'web_v2/troubleshoot/stepThree.png',
  },
  {
    seq: 'Step 4',
    title: 'Once the GREEN LED is on, the reset is successful.',
    subtitle:
      'On completion, wait for the Ring to connect to the App. If the connection is not successful, repeat the process.',
    img: 'web_v2/troubleshoot/stepFour.png',
  },
];

const MoreTroubleshootingSteps = [
  {
    title: 'Toggle Off/On your phone’s bluetooth',
    subtitle:
      'Unpair/forget the Ring from the Bluetooth menu of your phone settings > Bluetooth (Device name will start with UH______).',
    btn: '',
  },
  {
    title: 'Restart your phone',
    subtitle:
      'Restart your phone, reopen the app, go to the ring battery view, click “Setup new Ring”, and connect the ring when it becomes visible.',
    btn: '',
  },
  {
    title: 'Try another Ring Reset method',
    subtitle:
      'If you are still not able to connect the ring, please try this reset method.',
    btn: 'Reset your ring',
  },
];

const SelfHelpSteps = [
  {
    title: 'What do the different LED lights on Ultrahuman Home mean ?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        <ol>
          <li>
            {' '}
            <strong>White LED:</strong> The device is new or in setup mode. This
            means:
            <ul>
              <li>
                You can activate Ultrahuman Home and set up the Wi-Fi
                connection.
              </li>
              <li>
                If this light appears again after setup, it might mean:
                <ul>
                  <li>The Wi-Fi details are outdated or incorrect.</li>
                  <li>
                    The device has been moved to a new location, and the saved
                    Wi-Fi details are no longer valid.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <br />
          <li>
            {' '}
            <strong>Green LED:</strong> The device is successfully connected to
            the network and working as expected.
          </li>
          <br />
          <li>
            {' '}
            <strong>Red LED:</strong> Ultrahuman Home is disconnected from the
            Wi-Fi network.
          </li>
          <br />
          <li>
            <strong>Yellow LED:</strong> The device is facing issues connecting
            to the server.
            <ul>
              <li>
                If this persists for a long time, it could indicate connectivity
                issues or missing data in your Ultrahuman app.
              </li>
            </ul>
          </li>
          <br />
          <li>
            {' '}
            <strong>Blue LED:</strong> Ultrahuman Home is undergoing a firmware
            update.
          </li>
          <br />
          <li>
            {' '}
            <strong>Purple LED:</strong> A firmware update failed, likely due to
            a timeout.
          </li>
        </ol>
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a White LED on my Ultrahuman Home. What should I do ?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        <strong>New Device:</strong> If you&apos;re setting up Ultrahuman Home
        for the first time, follow the setup instructions in the Ultrahuman app
        to connect it to your Wi-Fi.
        <br />
        <br />
        <strong>Existing Device:</strong> If this light reappears:
        <ul>
          <li>The stored Wi-Fi details might be outdated or invalid.</li>
          <li>
            The device may have been moved to a new location where the saved
            Wi-Fi doesn&apos;t work.
          </li>
        </ul>
        <br />
        <strong>Steps to Fix:</strong>
        <br />
        <ol>
          <li>
            On the Ultrahuman app, click the <strong>Device Icon</strong> in the
            top-right corner of the <strong>Home Tab</strong>.
          </li>
          <li>
            Select <strong>&quot;Switch Wi-Fi&quot;</strong> and reconfigure the
            Wi-Fi details.
          </li>
          <li>Ensure the Wi-Fi network is stable and within range.</li>
        </ol>
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a Green LED on Ultrahuman Home. What does this mean?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>

      <>
        This means your Ultrahuman Home is connected to Wi-Fi and working
        properly. No action is needed.
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a Red LED on Ultrahuman Home. What should I do?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        This indicates that Ultrahuman Home is disconnected from Wi-Fi.
        <br />
        <br />
        <strong>Steps to Fix:</strong>
        <ol>
          <li>Restart the device by pressing the power button once.</li>
          <li>
            Check Wi-Fi:
            <ul>
              <li>
                Move Ultrahuman Home closer to the Wi-Fi router if needed.
              </li>
              <li>
                Open the app, click the <strong>Home Icon</strong>, and select{' '}
                <strong>&quot;Switch Wi-Fi&quot;</strong> to update Wi-Fi
                details if necessary.
              </li>
            </ul>
          </li>
        </ol>
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a Yellow LED on Ultrahuman Home. What should I do?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        Ultrahuman Home is having trouble connecting to the server.
        <br />
        <br />
        <strong>Steps to Fix:</strong>
        <ol>
          <li>Check the Wi-Fi connection and signal strength.</li>
          <li>
            If the yellow light persists and you notice missing data in the
            Ultrahuman app:
            <ul>
              <li>Move Ultrahuman Home closer to your Wi-Fi router.</li>
              <li>Restart the device by pressing the power button once.</li>
              <li>
                Use the <strong>&quot;Switch Wi-Fi&quot;</strong> option in the
                app to reconfigure Wi-Fi if needed.
              </li>
            </ul>
          </li>
        </ol>
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a Blue LED on Ultrahuman Home. What does this mean?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        Ultrahuman Home is undergoing a firmware update.
        <br />
        <br />
        <strong>Steps to Follow:</strong>
        <ul>
          <li>
            Ensure the device stays connected to power and Wi-Fi during the
            update.
          </li>
          <li>Avoid turning off the device until the update is complete.</li>
        </ul>
      </>
    ),
    btn: '',
  },
  {
    title: 'I see a Purple LED on Ultrahuman Home. What should I do?',
    desc: (
      // <>
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      //   <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______). <br />
      //   <br />
      //   Unpair/forget the Ring from the Bluetooth menu of your phone settings{' '}
      //   {'>'} Bluetooth (Device name will start with UH______).
      // </>
      <>
        The firmware update has failed, likely due to a timeout.
        <br />
        <br />
        <strong>Steps to Fix:</strong>
        <ol>
          <li>Restart the device by pressing the power button once.</li>
          <li>
            Confirm that the device is connected to a stable Wi-Fi network
            before starting.
          </li>
        </ol>
      </>
    ),
    btn: '',
  },
];

export const SelfHelpGuide = ({
  className,
}: // setSelfHelp,
{
  className?: string;
  // f
}) => {
  // const backToMoreTroubleShootMethods = () => {
  //   if (setSelfHelp) {
  //     setSelfHelp(false);
  //   }
  // };

  const [active, setActive] = useState<number | null>(0);

  return (
    <div
      className={`${styles.selfHelpGuide}${className ? ` ${className}` : ''}`}
    >
      <div className={styles.moreMethods}>
        <div className={styles.header}>
          <button
            className={styles.back}
            // onClick={backToMoreTroubleShootMethods}
          >
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.8933 3.26721C12.2698 3.61411 12.3189 4.17992 12.0263 4.58323L11.9461 4.68046L6.96729 10H17.2538C17.8103 10 18.2615 10.4477 18.2615 11C18.2615 11.5128 17.8725 11.9355 17.3713 11.9933L17.2538 12H6.96829L11.9461 17.3196C12.2956 17.6931 12.3024 18.261 11.9806 18.6417L11.8933 18.7328C11.5169 19.0797 10.9447 19.0864 10.561 18.7671L10.4692 18.6805L3.14612 11L10.4692 3.31955C10.8479 2.91484 11.4855 2.89141 11.8933 3.26721Z"
                fill="white"
              />
            </svg> */}
          </button>

          <h1 className={styles.head}>
            {/* Self Help Guide */}
            Ultrahuman Home Self Help Guide
          </h1>
        </div>
        <div className={`${styles.content} u-hide-scrollbar`}>
          <h2 className={styles.title}> </h2>
          <div className={styles.steps}>
            {SelfHelpSteps.map((step, index) => (
              <button
                className={styles.step}
                key={index}
                onClick={() => {
                  if (index === active) {
                    setActive(null);
                    return;
                  }
                  setActive(index);
                }}
              >
                <div className={styles.titleBlock}>
                  <h3>{step.title}</h3>
                  <div
                    className={index === active ? styles.arrow : styles.rotateArrow}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="15"
                      viewBox="0 0 18 15"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.351472 14.4813C-0.0811089 14.0719 -0.114384 13.4277 0.251646 12.9822L0.351472 12.8752L5.15147 8.33263C5.58405 7.92325 6.26473 7.89176 6.73548 8.23816L6.84853 8.33263L11.6485 12.8752C12.1172 13.3187 12.1172 14.0378 11.6485 14.4813C11.2159 14.8906 10.5353 14.9221 10.0645 14.5757L9.95147 14.4813L6 10.7426L2.04853 14.4813C1.61595 14.8906 0.93527 14.9221 0.464521 14.5757L0.351472 14.4813Z"
                        fill="white"
                        fillOpacity="0.33"
                      />
                    </svg>
                  </div>
                </div>

                {index === active ? (
                  <div className={styles.subhead}>{step.desc}</div>
                ) : null}
                {/* {step.btn && <button>{step.btn}</button>} */}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MoreTroubleshootMethods = ({
  className,
  setShowMethods,
  setSelfHelp,
}: {
  className?: string;
  setShowMethods?: (value: boolean) => void;
  setSelfHelp?: (value: boolean) => void;
}) => {
  const backToTroubleshootSteps = () => {
    if (setShowMethods) {
      setShowMethods(false);
    }
  };

  const showSelfHelpScreen = () => {
    if (setSelfHelp) {
      setSelfHelp(true);
    }
  };

  return (
    <div
      className={`${styles.moreTroubleshootMethods}${
        className ? ` ${className}` : ''
      }`}
    >
      <div className={styles.moreMethods}>
        <div className={styles.header}>
          <button className={styles.back} onClick={backToTroubleshootSteps}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.8933 3.26721C12.2698 3.61411 12.3189 4.17992 12.0263 4.58323L11.9461 4.68046L6.96729 10H17.2538C17.8103 10 18.2615 10.4477 18.2615 11C18.2615 11.5128 17.8725 11.9355 17.3713 11.9933L17.2538 12H6.96829L11.9461 17.3196C12.2956 17.6931 12.3024 18.261 11.9806 18.6417L11.8933 18.7328C11.5169 19.0797 10.9447 19.0864 10.561 18.7671L10.4692 18.6805L3.14612 11L10.4692 3.31955C10.8479 2.91484 11.4855 2.89141 11.8933 3.26721Z"
                fill="white"
              />
            </svg>
          </button>

          <h1 className={styles.head}>Troubleshoot</h1>
        </div>

        <div className={styles.content}>
          <h2 className={styles.title}>More troubleshoot methods</h2>
          <div className={styles.steps}>
            {MoreTroubleshootingSteps.map((step, index) => (
              <div className={styles.step} key={index}>
                <h3>{step.title}</h3>
                <p className={styles.subhead}>{step.subtitle}</p>
                {step.btn && (
                  <button onClick={showSelfHelpScreen}>{step.btn}</button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const TroubleShootSteps = ({
  className,
  setShowMethods,
}: {
  className?: string;
  setShowMethods?: (value: boolean) => void;
}) => {
  const moreTroubleshootSteps = () => {
    if (setShowMethods) {
      setShowMethods(true);
    }
  };

  return (
    <div
      className={`${styles.troubleShootSteps}${
        className ? ` ${className}` : ''
      }`}
    >
      <div className={styles.head}>
        <h1 className={styles.header}>Troubleshoot</h1>
        <div className={styles.content}>
          <h2 className={styles.title}>How to troubleshoot your device</h2>
          <p className={styles.subtitle}>This would take couple of minutes.</p>
        </div>
      </div>
      <div className={styles.steps}>
        {TroubleshootingSteps.map((step, index) => (
          <div className={styles.step} key={index}>
            <p className={styles.sequence}>{step.seq}</p>
            <h3>{step.title}</h3>
            <p className={styles.subhead}>{step.subtitle}</p>
            <div className={styles.elementImage}>
              <Image
                src={step.img}
                alt={step.img}
                fill
                // width={150}
                // height={109}
                className="img"
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.moreMethods}>
        <h4>Still not connecting? </h4>
        <p>If it still doesn’t connect, try another reset method.</p>
        <button onClick={moreTroubleshootSteps}>
          More troubleshoot methods
        </button>
      </div>
    </div>
  );
};

export const TroubleShootComp = ({ className }: { className?: string }) => {
  // const [showMoreMethods, setShowMoreMethods] = useState(false);
  // const [showSelfHelp, setShowSelfHelp] = useState<boolean>(false);

  return (
    <div
      className={`${styles.troubleShootComp}${className ? ` ${className}` : ''}`}
    >
      {/* {showMoreMethods ? (
        showSelfHelp ? (
          <SelfHelpGuide setSelfHelp={setShowSelfHelp}/>
        ) : (
          <MoreTroubleshootMethods setSelfHelp={setShowSelfHelp} setShowMethods={setShowMoreMethods} />
        )
      ) : (
        <TroubleShootSteps setShowMethods={setShowMoreMethods} />
      )} */}
      <SelfHelpGuide
      // setSelfHelp={setShowSelfHelp}
      />
    </div>
  );
};
